/*
1：BPROCM920
2：BPROCM830
3：BPROCM960
4：BPROCM922S
5：BPROCM922
6：BPROCM962S
7：BPROCM962
8：BPROCM620
9：BPROCM520
*/
/*
20250425
本命が2つの商品が発生した。0は本命がひとつなので空にする
*/

result = new Array();
result['aaaa']= new Array(5,4,6,1);
result['aaab']= new Array(5,4,6,1);
result['aaba']= new Array(6,7,5,2);
result['aabb']= new Array(6,7,5,3);
result['abaa']= new Array(5,4,6,1);
result['abab']= new Array(5,4,6,1);
result['abba']= new Array(6,7,5,2);
result['abbb']= new Array(6,7,5,3);
result['baaa']= new Array(9,0,5,8);
result['baab']= new Array(9,0,8,5);
result['baba']= new Array(8,0,9,7);
result['babb']= new Array(8,0,9,7);
result['bbaa']= new Array(9,0,5,8);
result['bbab']= new Array(9,0,8,5);
result['bbba']= new Array(8,0,9,7);
result['bbbb']= new Array(8,0,9,7);

/*結果表示時の画像Altのために*/
//製品の並び順はこれ(520,620,920,830,960,922,962S)
//製品の並び順はこれ(920,830,960,922S,922,962S,962,620,520)

batAlt = new Array();
batAlt[1] = 'BPROCM920';
batAlt[2] = 'BPROCM830';
batAlt[3] = 'BPROCM960';
batAlt[4] = 'BPROCM922S';
batAlt[5] = 'BPROCM922';
batAlt[6] = 'BPROCM962S';
batAlt[7] = 'BPROCM962';
batAlt[8] = 'BPROCM620';
batAlt[9] = 'BPROCM520';

//ga引き渡し用の文字列
gaHiki = new Array();
gaHiki[1] = new Array();
gaHiki[1][0] = 'cm_ポケット位置';
gaHiki[1]['a'] = 'cm_縦型';
gaHiki[1]['b'] = 'cm_横型';

gaHiki[2] = new Array();
gaHiki[2][0] = 'cm_サイズ';
gaHiki[2]['a'] = 'cm_大きめ';
gaHiki[2]['b'] = 'cm_小さめ';

gaHiki[3] = new Array();
gaHiki[3][0] = 'cm_バックスタイル';
gaHiki[3]['a'] = 'cm_アートバック';
gaHiki[3]['b'] = 'cm_スタンダード系バック';

gaHiki[4] = new Array();
gaHiki[4][0] = 'cm_紐通し方式';
gaHiki[4]['a'] = 'cm_X巻き';
gaHiki[4]['b'] = 'cm_シングル巻き';


/*
回答のすべての組み合わせをchartData.jsに連想配列として定義。
　※chartData.jsは二宮のローカルマシンにDB.xlsとしてエクセルにて制作。
　　一旦csvにて書き出し、それを置換してJavaScriptの連想配列として精製。
回答する毎に?acbbbのように引数が付け足される。
　※戻って修正した場合は引数も最後尾が削除される
その引数を最終結果であるresult.htmlにて処理。
result['bdaab']= new Array(2,7,5);
のような連想配列のkeyとしてそのまま使用する。
new Array(2,7,5);
の部分は、本命、推奨、推奨の順に並んでいるのでそのままの並びで掲載。
おしまい。
*/

$(function() {
	qnum = '';
	hiki = '';

	//URL取得
	var url   = location.href;
	params = url.split("?");
	if(params[1]){
		hiki = params[1];
	}else{
		hiki = '';
	}
	//ページナンバー代入
	pNum = $('body').attr('data-pNum');

	//設問3のみボタン表示をコントロール
	//20220926-全組み合わせを見せる事にしたのでキャンセル
	/*if(pNum == 3){
		key = params[1].slice(-1);
		hdnBtnAr = new Array();
		if(key == 'a'){
			hdnBtnAr = Array('a','c');
		}else if(key == 'b'){
				hdnBtnAr = Array();
		}else if(key == 'c'){
				hdnBtnAr = Array('a','c');
		}else if(key == 'd'){
				hdnBtnAr = Array('b');
		}
		$(".qBtn").each(function(){
			for(i=0; i<hdnBtnAr.length; i++){
				if($(this).attr('data-qnum') == hdnBtnAr[i]){
					$(this).addClass('hdn');
				}
			}
		});
	}*/

	//設問選択
	$('.qBtn').click(function(){
		qnum = '';
		qnum += $(this).attr('data-qnum');
		//選択中のボタン処理
		$(".qBtn").each(function(){
			$(this).removeClass('current');
		});
		$(this).toggleClass('current');
	});

	//次へクリックしたら
	$('.nextBtn').click(function(){
		if(!qnum){
			alert('回答を選択してください');//未選択の場合のエラー文言
		}else{
			//alert(gaHiki[pNum][0]+':'+gaHiki[pNum][qnum]);
			gtag('event','cm_設問選択',{ 'cm_event_category':gaHiki[pNum][0],'cm_event_label':gaHiki[pNum][qnum] });
			//gtag('event','設問選択',{'questionno':'設問番号','answer':'解答'});
			nextURL = $(this).attr('data-nexturl');
			location.href= nextURL+'?'+hiki+qnum;
		}
	});

	//戻るボタン
	$('.prevBtn').click(function(){
		hiki = hiki.slice( 0, -1 ) ;//引数の最後尾を削除して戻す
		prevURL = $(this).attr('data-prevurl');
		location.href= prevURL+'?'+hiki;
	});

	//resultの処理
	//chartData.jsに連想配列で定義してあるので、そこから該当の値を取得して処理
	/*
	20250425
	本命が二つになったので、最初の2こまでは本命として処理、本命一個の場合は、配列データ作成時に2番目をゼロにしておく
	*/
	kaki = '';
	if(params[0].indexOf('result') != -1){
		key = params[1].substr(0,5);
		for(i = 0; i < result[key].length; i++){
			if(i == 0 || i == 1){/*20250425*/
				if(result[key][i]){/*20250425*/
					kaki += '<div class="resultBat honmei"><a href="#modal0'+result[key][i]+'" class="modal0'+result[key][i]+'" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0611/4430/1664/files/cm_img0'+result[key][i]+'_02.png" alt="'+batAlt[result[key][i]]+'"></a></div>';
				}
			}else{
				kaki += '<div class="resultBat suisyo"><a href="#modal0'+result[key][i]+'" class="modal0'+result[key][i]+'" target="_blank"><img src="https://cdn.shopify.com/s/files/1/0611/4430/1664/files/cm_img0'+result[key][i]+'_02.png" alt="'+batAlt[result[key][i]]+'"></a></div>';
			}
		}
		$('.resultBox').html(kaki);
	}
});


